<script>
	export let style = "";
</script>

<div class="loader" {style} />

<style>
	.loader {
		border: 3px solid var(--background-2);
		border-top: 3px solid var(--button);
		border-radius: 50%;
		width: 3rem;
		height: 3rem;
		margin: auto;
		animation: spinner 1.5s ease-in-out infinite;
	}
	@keyframes spinner {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
